import React, { Dispatch, SetStateAction, ReactNode } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

interface CustModalProps {
    open: boolean;
    setOpen?: Dispatch<SetStateAction<boolean>>;
    bodyData?: ReactNode;
    children?: ReactNode;
    className?: string;
    navigateURL?: string;
    onCloseModal?: () => void;
    shouldCloseOnOverLay?: boolean;
    width?: string;
}

const CustModal = ({ open, bodyData, children, setOpen, className, navigateURL, onCloseModal, shouldCloseOnOverLay = true, width }: CustModalProps) => {
    const navigate: NavigateFunction = useNavigate();

    React.useEffect(() => {
        return () => {
            document.body.classList.remove('ReactModal__Body--open');
        };
    }, []);

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '0',
            width: width ? width : 'auto',
            maxWidth: '90vw'
        },
    };

    const closeModal = () => {
        setOpen && setOpen(false);
        onCloseModal && onCloseModal()
        navigateURL && navigate(navigateURL);
    };

    return (
        <Modal
            shouldCloseOnOverlayClick={shouldCloseOnOverLay}
            isOpen={open}
            onRequestClose={closeModal}
            style={customStyles}
            appElement={document.getElementById('root') as HTMLElement}
            contentLabel="Modal"
            className={className ? className : ''}>
            {bodyData || children}
        </Modal>
    );
};

export default CustModal;
